import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useApi } from '../api/contexto'
import type { ErrorApi } from '../api/errores'
import type { RolUsuario, UsuarioPanel } from '../api/modelos'

/** Usuarios locales del panel (RF-34, RF-46). Solo admin. */
export function useUsuarios() {
  const api = useApi()
  return useQuery<UsuarioPanel[], ErrorApi>({
    queryKey: ['usuarios'],
    queryFn: ({ signal }) => api.pedir<UsuarioPanel[]>('/api/usuarios', { senal: signal }),
  })
}

function useRefrescar() {
  const qc = useQueryClient()
  return () => void qc.invalidateQueries({ queryKey: ['usuarios'] })
}

export function useCrearUsuario() {
  const api = useApi()
  const refrescar = useRefrescar()
  return useMutation<UsuarioPanel, ErrorApi, { email: string; nombre: string; rol: RolUsuario; password: string }>({
    mutationFn: (datos) => api.pedir<UsuarioPanel>('/api/usuarios', { metodo: 'POST', cuerpo: datos }),
    onSuccess: refrescar,
  })
}

export function useEditarUsuario() {
  const api = useApi()
  const refrescar = useRefrescar()
  return useMutation<UsuarioPanel, ErrorApi, { id: string; datos: { nombre?: string; rol?: RolUsuario; activo?: boolean } }>({
    mutationFn: ({ id, datos }) => api.pedir<UsuarioPanel>(`/api/usuarios/${id}`, { metodo: 'PATCH', cuerpo: datos }),
    onSuccess: refrescar,
  })
}

export function useRestablecerPassword() {
  const api = useApi()
  return useMutation<unknown, ErrorApi, { id: string; password: string }>({
    mutationFn: ({ id, password }) => api.pedir(`/api/usuarios/${id}/password`, { metodo: 'POST', cuerpo: { password } }),
  })
}
